const comments = [
  {
    user: '吃瓜第一线',
    time: '2小时前',
    content: '台北娜娜那条新爆料真的太劲爆了！暗网吃瓜的速度确实快，比别的平台早了好几个小时，不愧是独家一手资讯。',
    likes: 186,
    avatar: 'https://readdy.ai/api/search-image?query=An%20anonymous%20stylish%20avatar%20with%20warm%20orange%20and%20dark%20tone%2C%20modern%20minimal%20design%2C%20no%20text%2C%20abstract%20profile%20style&width=80&height=80&seq=avatar-01&orientation=squarish',
  },
  {
    user: '八卦小能手',
    time: '5小时前',
    content: '莫里秀那个深度揭秘看完真的震惊了，51吃瓜的编辑团队确实下功夫，每条信息都有来源标注，这种良心吃瓜网站不多了。',
    likes: 142,
    avatar: 'https://readdy.ai/api/search-image?query=An%20anonymous%20modern%20avatar%20with%20warm%20amber%20and%20dark%20accents%2C%20minimal%20abstract%20design%2C%20no%20text%2C%20profile%20style&width=80&height=80&seq=avatar-02&orientation=squarish',
  },
  {
    user: '理性吃瓜人',
    time: '8小时前',
    content: '玩偶姐姐的视频合集做得太好了，不用到处翻找，暗网吃瓜一站就能看全。而且更新速度真的一绝，每天都有新内容。',
    likes: 97,
    avatar: 'https://readdy.ai/api/search-image?query=An%20anonymous%20elegant%20avatar%20with%20warm%20pink%20and%20dark%20tone%2C%20minimal%20abstract%20style%2C%20no%20text%2C%20profile%20design&width=80&height=80&seq=avatar-03&orientation=squarish',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100/50">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center">
          吃瓜群众热评
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">
          来看看大家都在聊什么
        </p>
        <div className="mt-8 space-y-4">
          {comments.map((comment, i) => (
            <div
              key={i}
              className="rounded-xl border border-background-200/60 bg-background-50 p-5"
            >
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={comment.avatar}
                    alt={comment.user}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-sm font-semibold text-foreground-800">
                      {comment.user}
                    </span>
                    <span className="text-xs text-foreground-400">{comment.time}</span>
                  </div>
                  <p className="mt-2 text-sm text-foreground-500 leading-relaxed">
                    {comment.content}
                  </p>
                  <div className="mt-3 flex items-center gap-4">
                    <button className="flex items-center gap-1 text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                      <i className="ri-thumb-up-line"></i>
                      <span>{comment.likes}</span>
                    </button>
                    <button className="flex items-center gap-1 text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                      <i className="ri-chat-1-line"></i>
                      <span>回复</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}